import { render, staticRenderFns } from "./StartForm5.vue?vue&type=template&id=441bbdd9&scoped=true"
import script from "./StartForm5.vue?vue&type=script&lang=ts"
export * from "./StartForm5.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441bbdd9",
  null
  
)

export default component.exports